import React, { useState, useEffect } from "react";
import { Box, getColor, Typography } from "fds";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import utilsCommon from "../../shared/utils/common";
import { useTranslation } from "react-i18next";
const Service: React.FC = () => {
  const navigate = useNavigate();
  const CUSTOM_SERVICE = window.eco.isCustomService;

  const { t } = useTranslation();
  const { i18n } = useTranslation();

  if (CUSTOM_SERVICE === true) {
    if (i18n.language === "ko") {
      window.location.href = `/service_info_ko.html`;
    } else {
      window.location.href = `/service_info_en.html`;
    }
  }
  return CUSTOM_SERVICE ? (
    <div></div>
  ) : (
    <Box classes="service">
      <Box classes="service-left">
        <Box
          alignItems="center"
          maxWidth={497}
          direction="column"
          style={{ marginTop: "20%" }}
        >
          <img
            src={utilsCommon.renderWrapsodyECOLogo()}
            alt={"logo"}
            // height={76}
            width={306}
            className="service-left--logo cursor pointer"
            onClick={() => navigate(`${process.env.PUBLIC_URL}/login`)}
          />
          <img
            src={require("../../shared/images/pages/Signup/star.png")}
            alt={"logo"}
            className="service-left--star1"
          />
          <img
            src={require("../../shared/images/pages/Signup/star.png")}
            alt={"logo"}
            className="service-left--star2"
          />
          <Typography style={{ marginTop: "35px" }} type="h1">
            {t("login.service.title")}
          </Typography>
          <Typography
            type="body1_md"
            classes={"mg mt-20"}
            maxWidth={"90%"}
            textAlign={"center"}
            whiteSpace="break-spaces"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("login.service.info")}
          </Typography>

          <img
            src={require("../../shared/images/pages/Signup/people.png")}
            alt={"logo"}
            style={{ marginTop: 122 }}
          />
        </Box>
      </Box>
      <Box classes="service-right">
        <Box direction="column" classes="service-right--body">
          <Box alignItems="center" classes="edge">
            <img
              src={require("../../shared/images/pages/Signup/lock.png")}
              alt={"logo"}
              width={"64px"}
              height={"62px"}
            />
            <Typography type="h2" classes="h2">
              {t("login.service.explain1_1")}
              <span
                className="service-button"
                onClick={() =>
                  navigate(`${process.env.PUBLIC_URL}/checkSignup`)
                }
              >
                {t("login.service.explain1_2")}
              </span>
              {t("login.service.explain1_3")}
            </Typography>
          </Box>
          <Box alignItems="center">
            <img
              src={require("../../shared/images/pages/Signup/human.png")}
              alt={"logo"}
              width={"64px"}
              height={"62px"}
            />
            <Typography type="h2">
              {t("login.service.explain2_1")}
              <Typography
                type="h2"
                classes={"mg ml-4 service-button"}
                exactColor={getColor("COLOR_GREEN_60")}
                onClick={() => navigate(`${process.env.PUBLIC_URL}/login`)}
              >
                {t("login.service.explain2_2")}
              </Typography>
              {t("login.service.explain2_3")}
            </Typography>
          </Box>
          <Box alignItems="center">
            <img
              src={require("../../shared/images/pages/Signup/request.png")}
              alt={"logo"}
              width={"64px"}
              height={"62px"}
            />
            <Typography type="h2">{t("login.service.explain3")}</Typography>
          </Box>
          <Box alignItems="center">
            <img
              src={require("../../shared/images/pages/Signup/search.png")}
              alt={"logo"}
              width={"64px"}
              height={"62px"}
            />
            <Typography type="h2">{t("login.service.explain4")}</Typography>
          </Box>
          <Box alignItems="center" classes="edge">
            <img
              src={require("../../shared/images/pages/Signup/setting.png")}
              alt={"logo"}
              width={"64px"}
              height={"62px"}
            />
            <Typography type="h2">
              {t("login.service.explain5_1")}
              <Typography
                type="h2"
                classes={"mg ml-4 service-button"}
                exactColor={getColor("COLOR_GREEN_60")}
                onClick={() =>
                  navigate(`${process.env.PUBLIC_URL}/downloadClient`)
                }
              >
                {t("login.service.explain5_2")}
              </Typography>
              {t("login.service.explain5_3")}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Service;
